import React, { useEffect } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PropTypes from 'prop-types';
import {
  Card,
  CardTitle,
  CardDescription,
  PrimaryButton,
} from '../styledComponents';

export default function StepConfirmacion({ onFinish }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Card>
      <CheckCircleIcon style={{ fontSize: 36, color: '#00843d' }} />
      <CardTitle>¡Listo!</CardTitle>
      <CardDescription>
        Tu registro fue exitoso. En breve un asesor PrestaVale se pondrá en
        contacto contigo.
      </CardDescription>
      <PrimaryButton onClick={onFinish}>Ir al inicio</PrimaryButton>
    </Card>
  );
}

StepConfirmacion.propTypes = {
  onFinish: PropTypes.func.isRequired,
};
